import React from "react";
import { AxiosError } from "axios";
import { MakeRequest } from "../DataUtil";
import SmallSpinner from "../SmallSpinner";
import { sanitizeInput, Validator } from "../Validation/Validator";
import {
  getAllFormElements,
  showValidationErrors,
  resetValidationErrors,
  Redirect,
} from "../Utilities";
import ValidationSummary from "../Validation/ValidationSummary";
import { setToaster } from "../Toaster";
import { ToastContainer } from "react-toastify";
import Recaptcha from "../Recaptcha";

const recaptchaUtil = new Recaptcha("submit");

interface Props {
  Title: string;
}

interface State {
  name: string;
  email: string;
  subject: string;
  message: string;
  isLoading: boolean;
  formErrors: any;
  renderCount: number;
  redirect: boolean;
  recaptchaResult: boolean;
}

class ContactForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      subject: "",
      message: "",
      isLoading: false,
      formErrors: [],
      renderCount: 0,
      redirect: false,
      recaptchaResult: false,
    };
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleSubjectChange = this.handleSubjectChange.bind(this);
    this.handleMessageChange = this.handleMessageChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  /*verify = async (data: any, e: any) => {
    //process results from ajax call
    const successCallback = (result: any): void => {
      if (result && result.success) {
        this.setState(
          {
            recaptchaResult: result.success,
          },
          () => {
            this.handleSubmitData(e);
          }
        );
      } else if (result !== null && result !== undefined) {
        setToaster({
          state: { error: true },
          message: "Failed: Errors encountered in recaptcha",
        });
      } else {
        setToaster({
          state: { error: true },
          message: "Failed: Errors encountered in recaptcha: " + result.Message,
        });
      }
    };
    //handle errors
    const errorCallback = (error: AxiosError): void => {
      if (error) {
        this.setState({ isLoading: false });
        setToaster({
          state: { error: true },
          message: error.response ? error.message : "Unknown Error",
        });
      }
    };
    recaptcha({
      url: "Contact/SiteVerify",
      data: data,
      successCallback,
      errorCallback,
    });
  };*/
  postData(data: any): void {
    //process results from ajax call
    const successCallback = (result: any): void => {
      if (result && result !== undefined) {
        //do logic
        if (result.Success === true) {
          this.onToaster({ success: true }, "Success: Message Sent");
          this.setState({
            name: "",
            email: "",
            subject: "",
            message: "",
            redirect: true,
          });
        } else {
          this.onToaster({ error: true }, "Error: " + result.Message);
          this.setState({ isLoading: false });
        }
      }
    };
    //handle errors
    const errorCallback = (error: AxiosError): void => {
      if (error) {
        this.setState({ isLoading: false });
        this.setState({ isLoading: false }, () => {
          this.onToaster(
            { error: true },
            error.response ? error.message : "Unknown Error"
          );
        });
      }
    };
    MakeRequest({
      url: "Contact",
      method: "post",
      data: { postData: data },
      successCallback,
      errorCallback,
      EncType: data.EncType,
    });
  }
  handleBlurValidation = (e: any) => {
    let errors = Validator({ fields: e.target });
    if (errors.length === 0) {
      this.setState({ formErrors: [] }, () => {
        resetValidationErrors(e.target);
      });
    } else {
      this.setState({ formErrors: errors }, () => {
        showValidationErrors(this.state.formErrors);
      });
    }
  };

  handleFocus = (e: any) => {
    this.setState({ formErrors: [] }, () => {
      resetValidationErrors(e.target);
    });
  };
  handleNameChange = (e: any) => {
    if (e !== null && e !== undefined) {
      let clean = sanitizeInput(e.target.value, e.target.type);
      this.setState({ name: clean });
    }
  };
  handleEmailChange = (e: any) => {
    if (e !== null && e !== undefined) {
      let clean = sanitizeInput(e.target.value, e.target.type);
      this.setState({ email: clean });
    }
  };
  handleSubjectChange = (e: any) => {
    if (e !== null && e !== undefined) {
      let clean = sanitizeInput(e.target.value, e.target.type);
      this.setState({ subject: clean });
    }
  };
  handleMessageChange = (e: any) => {
    if (e !== null && e !== undefined) {
      let clean = sanitizeInput(e.target.value, e.target.type);
      this.setState({ message: clean });
    }
  };
  onToaster = (state: any, message: string): void => {
    setToaster({
      state: state,
      message: message,
    });
  };
  getRecaptchaToken = async (): Promise<any> => {
    try {
      return await new Promise((resolve: any, reject: any) => {
        let token: any = recaptchaUtil.getToken();
        if (token !== null && token !== undefined) {
          return resolve(token);
        } else {
          return reject(new Error("rejected"));
        }
      });
    } catch {
      return new Promise((reject: any) => {
        return reject("");
      });
    }
  };
  createRecaptchaAssessment = async (
    token: string,
    successCallback: any,
    errorCallback: any
  ): Promise<any> => {
    try {
      return await new Promise((resolve: any, reject: any) => {
        let result: any = recaptchaUtil.getAssessment(
          token,
          successCallback,
          errorCallback
        );
        if (result !== null && result !== undefined) {
          return resolve(result);
        } else {
          return reject(new Error("rejected"));
        }
      });
    } catch {
      return new Promise((reject: any) => {
        return reject("");
      });
    }
  };
  handleSubmit = async (e: any) => {
    if (e !== null && e !== undefined) {
      e.preventDefault();
      let result: any = {
        response: await this.getRecaptchaToken(),
      };
      if (result !== "") {
        const successCallback = (result: any): void => {
          if (result) {
            //process recaptcha assessment
            if (
              result.tokenProperties?.valid &&
              result.riskAnalysis?.score > 0.5
            ) {
              //all good, submit form
              this.handleSubmitData(e);
            } else {
              //assessment failed, redirect
              if (!result.tokenProperties?.valid) {
                console.log(result.tokenProperties?.invalidReason);
              }
              if (result.riskAnalysis?.score < 0.5) {
                result.riskAnalysis?.reasons.foreach((reason: any) => {
                  console.log(reason);
                });
              }
              this.setState({ redirect: true });
            }
          }
        };
        //handle errors
        const errorCallback = (error: AxiosError): any => {
          if (error) {
            return error.message;
          }
        };
        await this.createRecaptchaAssessment(
          result.response,
          successCallback,
          errorCallback
        );
      }
    }
  };
  handleSubmitData = (e: any): any => {
    this.setState({ isLoading: true });
    const name: string = this.state.name.trim();
    const email: string = this.state.email.trim();
    const subject: string = this.state.subject.trim();
    const message: string = this.state.message.trim();
    let form = document.getElementById("contactForm");
    let allFormElements = getAllFormElements({ element: form || e });
    let errors = Validator({ fields: allFormElements });

    if (errors.length === 0) {
      //update state
      let contact: any = {
        ReplyTo: email,
        ReplyToName: name,
        Subject: subject,
        Body:
          "From: " + name + "<p>" + email + "<p/>" + "<p>" + message + "<p/>",
      };
      this.setState({ formErrors: [] }, () => {
        resetValidationErrors(e.target);
        //save the data
        this.postData(contact);
      });
    } else {
      this.setState({ isLoading: false, formErrors: errors }, () => {
        showValidationErrors(this.state.formErrors);
      });
    }
  };
  render() {
    return (
      <>
        <div className="wrapper">
          <div className="section latest-offers">
            <div className="container">
              <h3 className="section-title">{this.props.Title}</h3>
              <hr />
              <div className="col-md-7 col-sm-8">
                <div className="card-form">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-12">
                        <SmallSpinner
                          isLoading={this.state.isLoading}
                          actionText="Please Wait"
                        />
                      </div>
                    </div>
                  </div>
                  <ValidationSummary Errors={this.state.formErrors} />
                  <form
                    id="contactForm"
                    onSubmit={this.handleSubmit}
                    encType="multipart/form-data"
                  >
                    <div className="form-group">
                      <label htmlFor="name" className="label-dark">
                        Name
                      </label>
                      <input
                        id="name"
                        className="form-control border-input"
                        type="text"
                        value={this.state.name || ""}
                        onChange={this.handleNameChange}
                        onBlur={this.handleBlurValidation}
                        onFocus={this.handleFocus}
                        placeholder="Name"
                        data-required="true"
                        data-validationname="Name"
                        data-id="name"
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="email" className="label-dark">
                        Email
                      </label>
                      <input
                        id="email"
                        className="form-control border-input"
                        type="email"
                        value={this.state.email || ""}
                        onChange={this.handleEmailChange}
                        onBlur={this.handleBlurValidation}
                        onFocus={this.handleFocus}
                        placeholder="Email"
                        data-required="true"
                        data-validationname="Email"
                        data-id="email"
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="subject" className="label-dark">
                        Subject
                      </label>
                      <input
                        id="subject"
                        className="form-control border-input"
                        type="text"
                        value={this.state.subject || ""}
                        onChange={this.handleSubjectChange}
                        onBlur={this.handleBlurValidation}
                        onFocus={this.handleFocus}
                        placeholder="Subject"
                        data-required="true"
                        data-validationname="Subject"
                        data-id="subject"
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="message" className="label-dark">
                        Message
                      </label>
                      <textarea
                        id="message"
                        className="form-control border-input"
                        value={this.state.message || ""}
                        onChange={this.handleMessageChange}
                        onBlur={this.handleBlurValidation}
                        onFocus={this.handleFocus}
                        placeholder="Message"
                        data-required="true"
                        data-validationname="Message"
                        data-id="message"
                      ></textarea>
                    </div>
                    <div className="card-footer">
                      <div className="col-md-12">
                        <button
                          className="btn btn-default btn-round"
                          data-id="SubmitBtn"
                          type="submit"
                        >
                          Submit
                        </button>
                      </div>
                      <div className="col-md-12">
                        <small className="google-text">
                          {" "}
                          This site is protected by reCAPTCHA and the Google
                          <a href="https://policies.google.com/privacy">
                            Privacy Policy
                          </a>{" "}
                          and
                          <a href="https://policies.google.com/terms">
                            Terms of Service
                          </a>{" "}
                          apply.
                        </small>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer autoClose={2000} />
        {this.state.redirect && <Redirect path="/MessageSent" />}
      </>
    );
  }
}

export default ContactForm;
